import React from "react";
import useTranslations from "../hooks/useTranslations";
import { isNullOrWhiteSpace } from "../shared/string";

export interface ContactCardProps {
    officeHours?: {
        days: string;
        openingHours: string;
    }[];
    phoneNumber?: string;
    title?: string;
    address?: string;
    visitorAddress?: string;
}

const ContactDetailsBlock = (props: ContactCardProps) => {
    const { address, visitorAddress, officeHours, phoneNumber, title } = props;
    const translations = useTranslations();
    return (
        <div className="flex flex-col justify-center border border-form-border w-full lg:w-auto lg:shadow-lg px-4 py-8 lg:px-16 lg:pt-12 lg:pb-16">
            {!isNullOrWhiteSpace(title) && (
                <h3 className="text-3xl mb-6 text-h3-primary">{title}</h3>
            )}
            {!isNullOrWhiteSpace(address) && (
                <>
                    <h4 className="text-contact-info-h4 font-bold uppercase text-lg">
                        {translations.address}
                    </h4>
                    <p className="text-xl mb-6">{address}</p>
                </>
            )}
            {!isNullOrWhiteSpace(visitorAddress) && (
                <>
                    <h4 className="text-contact-info-h4 font-bold uppercase text-lg">
                        {translations.visitorAddress}
                    </h4>
                    <p className="text-xl mb-6">{visitorAddress}</p>
                </>
            )}
            {!isNullOrWhiteSpace(phoneNumber) && (
                <>
                    <h4 className="text-contact-info-h4 font-bold uppercase text-lg">
                        {translations.phoneNumber}
                    </h4>
                    <p className="text-xl mb-6">{phoneNumber}</p>
                </>
            )}
            <h4 className="text-contact-info-h4 font-bold uppercase text-lg">
                {translations.officeHours}
            </h4>
            {officeHours && (
                <ul className="text-paragraph-primary text-xl">
                    {officeHours.map(officeHour => (
                        <li
                            key={officeHour.days}
                            className="flex justify-between"
                        >
                            {!isNullOrWhiteSpace(
                                officeHour.days
                            ) &&
                            <div>{officeHour.days}</div>
                            }
                            {!isNullOrWhiteSpace(
                                officeHour.openingHours
                            ) &&
                            <div className="font-bold">
                                {officeHour.openingHours}
                            </div>
                            }
                        </li>
                    ))}
                </ul>
            )}
        </div>
    );
};

export default ContactDetailsBlock;
